'use strict';

var cache = {};

module.exports = {
    initSBFCache: function () {
        cache.$document = $(document);
        cache.$sbfFilterInput = $('.js-fragrance-filter');
        cache.$sbfLink = $('.js-bbw-sbf-link');
        cache.$sbfContainers = $('.js-bbw-sbf-container');
        cache.$sbfVizibleContainers = $('.js-bbw-sbf-container:visible');
    },
    updateBorderOnBpChange: function () {
        var _this = this;

        window.jRes.addFunc([
            {
                breakpoint: ['xsmall', 'small', 'medium', 'large'],
                enter: function () {
                    _this.updateBorderBottom(3);
                },
                exit: function () {
                    _this.updateBorderBottom(3);
                }
            },
            {
                breakpoint: ['extraLarge', 'extraExtraLarge'],
                enter: function () {
                    _this.updateBorderBottom(4);
                },
                exit: function () {
                    _this.updateBorderBottom(4);
                }
            }
        ]);
    },
    updateBorderBottom: function (_columnConfig) {
        var _this = this;
        _this.initSBFCache();

        var columnConfig = _columnConfig || 4;
        var containers  = cache.$sbfVizibleContainers.length;
        var index = containers - (containers % columnConfig);

        cache.$sbfVizibleContainers.removeClass('bbw-no-border');

        for (var i = containers; i >= index ; i--) {
            $(cache.$sbfVizibleContainers[i]).addClass('bbw-no-border');
        }
    },
    initSbfFilter: function () {
        var _this = this;
        _this.initSBFCache();

        cache.$sbfFilterInput.on('keyup', function () {
            var $input = $(this);
            var value = $input.val().toLowerCase();

            // Filter links based on input value
            cache.$sbfLink.filter(function () {
                var $this = $(this);
                $this.toggleClass('d-none', $this.text().toLowerCase().indexOf(value) === -1);
            });

            // Filter containers based on links
            cache.$sbfContainers.filter(function () {
                var $this = $(this);
                $this.toggle($this.find('.js-bbw-sbf-link').length !== $this.find('.js-bbw-sbf-link.d-none').length);
            });

            _this.updateBorderBottom();
        });
    },
};
